module.exports = __webpack_public_path__ + "img/icn_transportation5.306616e2.png";